(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coc-product-landing-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function boot(){document.querySelectorAll('[data-coc-product-landing]').forEach(root=>{if(root.dataset.cocKitReady)return;root.dataset.cocKitReady='1';const dialog=root.querySelector('[data-coc-kit-dialog]'),open=root.querySelector('[data-coc-kit-open]');if(!dialog||!open)return;const images=[...dialog.querySelectorAll('[data-coc-kit-image]')],step=dialog.querySelector('[data-coc-kit-step]');let current=0;function show(index){current=(index+images.length)%images.length;images.forEach((img,i)=>img.hidden=i!==current);step.textContent=String(current+1).padStart(2,'0')+' / '+images.length}open.addEventListener('click',()=>{show(0);dialog.showModal()});dialog.querySelector('[data-coc-kit-close]').addEventListener('click',()=>dialog.close());dialog.querySelector('[data-coc-kit-prev]').addEventListener('click',()=>show(current-1));dialog.querySelector('[data-coc-kit-next]').addEventListener('click',()=>show(current+1));dialog.querySelector('[data-coc-kit-included]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});dialog.addEventListener('keydown',e=>{if(e.key==='ArrowRight')show(current+1);if(e.key==='ArrowLeft')show(current-1)})});document.querySelectorAll('[data-coc-pdl-scene]').forEach(scene=>{
    if(scene.dataset.coc3dReady)return;scene.dataset.coc3dReady='1';
    const box=scene.querySelector('[data-coc-pdl-box]');if(!box)return;
    const controls=scene.parentElement.querySelector('.coc-pdl-rotate-controls'),pause=controls.querySelector('[data-coc-pdl-pause]');
    let angle=-18,lastX=0,dragging=false,auto=!matchMedia('(prefers-reduced-motion: reduce)').matches,lastTime=0,visible=true,frame=0;
    function paint(){box.style.transform='rotateX(-11deg) rotateY('+angle.toFixed(2)+'deg)'}
    function draw(time){frame=0;if(!visible)return;if(auto&&lastTime)angle=(angle+Math.min(time-lastTime,50)*.012)%360;lastTime=time;paint();frame=requestAnimationFrame(draw)}
    scene.addEventListener('pointerdown',e=>{dragging=true;lastX=e.clientX;scene.setPointerCapture(e.pointerId)});
    scene.addEventListener('pointermove',e=>{if(dragging){angle=(angle+(e.clientX-lastX)*.7+3600)%360;lastX=e.clientX;paint()}});
    scene.addEventListener('pointerup',()=>dragging=false);scene.addEventListener('pointercancel',()=>dragging=false);
    pause.addEventListener('click',()=>{auto=!auto;lastTime=0;pause.setAttribute('aria-pressed',String(!auto));pause.textContent=auto?'Ⅱ':'▶';pause.setAttribute('aria-label',auto?'Pause 3D rotation':'Play 3D rotation')});
    controls.querySelector('[data-coc-pdl-reset]').addEventListener('click',()=>{angle=-18;paint()});
    if('IntersectionObserver'in window)new IntersectionObserver(([entry])=>{visible=entry.isIntersecting;lastTime=0;if(visible&&!frame)frame=requestAnimationFrame(draw);else if(!visible&&frame){cancelAnimationFrame(frame);frame=0}},{threshold:.04}).observe(scene);
    paint();frame=requestAnimationFrame(draw)
  })}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();document.addEventListener('shopify:section:load',boot)
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coc-workplace-challenge"] && !Shopify.designMode) return;
  try {
    
(function(){function boot(){document.querySelectorAll('[data-coc-challenge]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const messages=[['A reasonable reaction, but it may turn feedback into a dispute.','Ask what matters most for the meeting and make the next step specific.'],['Clear and constructive.','You clarify the priority, set a realistic scope, and act within the time available.'],['Generous, but too broad for five minutes.','Clarify the most important change before committing to a full rewrite.']];const result=root.querySelector('.coc-challenge-result');root.querySelectorAll('[data-answer]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-answer]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));const [heading,body]=messages[Number(button.dataset.answer)];result.querySelector('strong').textContent=heading;result.querySelector('p').textContent=body;result.hidden=false}));root.querySelector('[data-retry]').addEventListener('click',()=>{result.hidden=true;root.querySelectorAll('[data-answer]').forEach(b=>b.setAttribute('aria-pressed','false'));root.querySelector('[data-answer]').focus()})})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();document.addEventListener('shopify:section:load',boot)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
